import SeoContext from '../../lib/seo-context';
import Layout from '../../components/layout';
import HeroSubpage from '../../components/hero-subpage';
import { Merge } from '../../lib/helper';
import { fetchAPI } from '../../lib/api';
import Image from 'next/image';
import Link from 'next/link';

const Page = (props) => {

    const { pageProps, global } = props;
    if (!pageProps) {
        return '';
    }

    const seo = Merge(global.seo, pageProps.seo);
    seo.canonicalURL = `${process.env.NEXT_PUBLIC_SITE_URL}/team/${pageProps.slug}`;

    return (
        <SeoContext.Provider value={seo}>
            <Layout
                footerClass="skew-maturity-100"
                languageData={{ originalSlug: pageProps.originalSlug, languages: pageProps.localizations }}
            >
                <HeroSubpage content={`<h1>${pageProps.fullName}</h1><p> <strong className="mb-4">${pageProps.title}</strong></p>`}></HeroSubpage>
                <section className="container max-w-screen-xl mx-auto -mt-10 pb-10 relative z-10">
                    <div className="flex flex-col lg:flex-row px-10 xl:px-0">
                        <div className="flex flex-col md:flex-row w-full  relative">
                            <div className="flex flex-col md:w-1/3">
                                <div className="flex flex-col w-full mx-auto text-left justify-start md:pr-8 mb-8 ">
                                    <Image
                                        src={pageProps.photo.data.attributes.url}
                                        alt={pageProps.photo.data.attributes.alternativeText}
                                        width={pageProps.photo.data.attributes.width}
                                        height={pageProps.photo.data.attributes.height}
                                        className="rounded-md overflow-hidden object-cover w-full h-full"
                                    />
                                </div>
                                <div className="flex flex-col w-full mx-auto text-left justify-start pr-8 mb-10">

                                    {pageProps.linkedin &&
                                        <Link href={pageProps.linkedin}>
                                            <a target="_blank" className='flex flex-row text-trust pb-2'>
                                                <i className="flaticon-linkedin flex mr-3 text-3xl opacity-50 hover:opacity-100 transition duration-300"></i>
                                                <div className="py-1 text-ellipsis overflow-hidden  whitespace-nowrap flex">{pageProps.linkedin}</div>
                                            </a>
                                        </Link>}

                                    {pageProps.twitter &&
                                        <Link href={pageProps.twitter}>
                                            <a target="_blank" className='flex flex-row text-trust pb-2'>
                                                <i className="flaticon-twitter flex mr-3 text-3xl opacity-50 hover:opacity-100 transition duration-300"></i>
                                                <div className="py-1 text-ellipsis overflow-hidden inline-block whitespace-nowrap">{pageProps.twitter}</div>
                                            </a>
                                        </Link>}

                                    <Link href="/our-team">
                                        <a className='flex flex-row mt-10 mb-2'>
                                            <i className="flaticon-left-arrow flex mr-3 text-3xl opacity-50 hover:opacity-100 transition duration-300"></i>
                                            <div className="py-1 text-ellipsis overflow-hidden inline-block whitespace-nowrap">Back</div>
                                        </a>
                                    </Link>
                                </div>

                            </div>
                            <div className="flex flex-col basis-full md:w-2/3">

                                {pageProps.bio && (
                                    <>
                                        <h2 className='font-semibold text-3xl'>Biography</h2>
                                        <div className="my-4" dangerouslySetInnerHTML={{ __html: pageProps.bio }}></div>
                                    </>
                                )}

                                {pageProps.blog_articles.data.length > 0 && (
                                    <>
                                        <h2 className='font-semibold text-3xl'>Articles</h2>
                                        <ul>
                                            {pageProps.blog_articles.data.map((article) => (
                                                <li key={article.id} className='flex justify-start items-center'><i className="flaticon-right-arrow text-2xl text-trust mt-1 mx-2"></i> <Link href={`/blog/articles/${article.attributes.slug}`}><a className='text-trust hover:text-trust-900'>{article.attributes.title}</a></Link></li>
                                            ))}
                                        </ul>
                                    </>
                                )}

                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </SeoContext.Provider>

    );
}
export default Page;

export async function getStaticPaths({ locales }) {
    const paths = [];
    await Promise.all(
        locales.map(async (locale) => {
            const results = await fetchAPI('/teams', { locale, populate: 'deep,1' });
            return results.data.map((page) => {
                return paths.push({
                    params: {
                        slug: page.attributes.slug
                    },
                    locale
                });
            });
        })
    );

    return {
        paths,
        fallback: true
    };
}

export async function getStaticProps({ params, locale }) {
    try {
        const result = await fetchAPI(`/team/by-slug/${params.slug}`, {
            populate: 'deep,3',
            locale
        });

        return {
            props: { pageProps: result.data.attributes },
            revalidate: Number(process.env.NEXT_PUBLIC_PAGE_REVALIDATION) || 100
        };
    } catch (e) {
        console.log('got an error', e.message);
        return { notFound: true };
    }
}